import React, { useState } from "react";
import { CloseIcon } from "@icarius-icons";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    TextField,
    DialogActions,
} from "@material-ui/core";
import DialogTitleDivider from "@icarius-common/dialogTitleDivider";
import PaperDraggable from "@icarius-common/paperDraggable";
import DialogTransition from "@icarius-common/dialogTransition";
import { useDispatch } from "react-redux";
import { getLocalizedString } from "@icarius-localization/strings";
import TextEditor from "@icarius-common/textEditor";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import ButtonDialogAction from "@icarius-common/buttonDialogAction";
import { createQuestionFromTrainingAction } from "@icarius-pages/myTraining/actions";

const CreateQuestionDialog = (props) => {

    const {
        open,
        trainingData,
        activityData,
        handleClose,
    } = props;

    const [title, setTitle] = useState("");
    const [content, setContent] = useState("");
    const [contentHTML, setContentHTML] = useState("");

    const dispatch = useDispatch();

    const submit = () => {
        if (!title || !content) {
            dispatch(openSnackbarAction({ msg: getLocalizedString("invalidData"), severity: "error", duration: 10000 }));
            return;
        }

        dispatch(createQuestionFromTrainingAction(trainingData.id, activityData.id, { title, content, contentHTML }))
            .then((resp) => {
                if (resp.status === 200) {
                    handleClose();
                }
            })
    }

    if (!open) return null;

    return (
        <Dialog
            open={open}
            TransitionComponent={DialogTransition}
            PaperComponent={PaperDraggable}
            maxWidth={"md"}
            fullWidth={true}
        >
            <div className={"dialog-container"}>
                <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
                    {getLocalizedString("createQuestion")}
                    <DialogTitleDivider />
                </DialogTitle>
                <CloseIcon className={"dialog-close-icon icon"} onClick={handleClose} />
                <DialogContent style={{ paddingTop: 0, paddingBottom: 20 }}>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            flexWrap: "wrap",
                            gap: 10,
                            flex: 1,
                            alignItems: "flex-end",
                        }}
                    >
                        <TextField
                            fullWidth
                            required
                            margin={"none"}
                            label={getLocalizedString("title")}
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                            inputProps={{ maxLength: 254 }}
                        />
                        <div style={{ width: "100%" }}>
                            <TextEditor
                                initialValue={""}
                                placeholder={getLocalizedString("ask")}
                                handleChange={(content, contentHTML) => {
                                    setContent(content);
                                    setContentHTML(contentHTML);
                                }}
                                allowImages
                            />
                        </div>
                    </div>
                </DialogContent>
                <DialogActions>
                    <ButtonDialogAction onClick={handleClose} text={getLocalizedString("cancel")} />
                    <ButtonDialogAction onClick={submit} isAccept text={getLocalizedString("accept")} />
                </DialogActions>
            </div>
        </Dialog>
    );
}

export default CreateQuestionDialog;